import AOS from 'aos';

// check if AOS is defined
if(typeof AOS !== 'undefined') {
    $(window).on("scroll", function () {
        AOS.init({
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            duration: 1000, // values from 0 to 3000, with step 50ms
            offset: -100, // offset (in px) from the original trigger point
            once: false, // whether animation should happen only once - while scrolling down
        });
    });
    AOS.init({
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        duration: 1000, // values from 0 to 3000, with step 50ms
        offset: -100, // offset (in px) from the original trigger point
        once: false, // whether animation should happen only once - while scrolling down
    });
} else {
    console.log('AOS is not ready');
}
